import { render, staticRenderFns } from "./UserAddEmailDialog.vue?vue&type=template&id=64f9d536&scoped=true&"
import script from "./UserAddEmailDialog.vue?vue&type=script&lang=js&"
export * from "./UserAddEmailDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserAddEmailDialog.vue?vue&type=style&index=0&id=64f9d536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f9d536",
  null
  
)

export default component.exports